// extracted by mini-css-extract-plugin
export default {"main":"verbo_main__O9hxk","text":"verbo_text__7xBj1","button":"verbo_button__AH2I2","header":"verbo_header__Yy5tg"};